import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'subdomain',
	key: 'subdomain_id',
	fields: {
		subdomain_id: Model.SCHEMA_NUMBER,
		subdomain_name: Model.SCHEMA_TEXT
	},
	methods: {
		to_array: function() {
			return {
				subdomain_id: this.get_id(),
				subdomain_name: this.rawData().subdomain_name
			}
		}
	}
})
